var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFilter = function SvgFilter(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 18a.97.97 0 0 1-.713-.288A.97.97 0 0 1 10 17q0-.424.287-.712A.97.97 0 0 1 11 16h2q.424 0 .713.288.287.287.287.712 0 .424-.287.712A.97.97 0 0 1 13 18zm-4-5a.97.97 0 0 1-.713-.287A.97.97 0 0 1 6 12q0-.424.287-.713A.97.97 0 0 1 7 11h10q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 17 13zM4 8a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 7q0-.424.288-.713A.97.97 0 0 1 4 6h16q.424 0 .712.287Q21 6.576 21 7q0 .424-.288.713A.97.97 0 0 1 20 8z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };